var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.5 5.53979V19.5398","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.5 12.5398H19.5","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Plus.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
